import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { IPageHeader } from '../../../../../Components/pageheader/pageHeader.model';
import { PageheaderComponent } from '../../../../../Components/pageheader/pageheader.component';
import { ACADEMIC_DATA } from '../../academics.data';
import { RouterOutlet } from '@angular/router';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { ArticlesViewComponent } from '../../../../../Components/articles-view/articles-view.component';
import { BaseComponent } from '../../../../base.component';
import { IPopup } from '../../../../../Components/popup/popup.model';
import {
  DOMAIN_TYPE,
  NATIONAL_PAGES,
  SCHEMA_TYPE,
} from '../../../../../constants';
import { AutoUnsubscribe } from '../../../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../../../Services/schoolApi.service';
import { IList } from '../../../../../Models/list.model';
import { IResponse } from '../../../../../Models/response.model';
import { ISchoolArticle } from '../../../../../Models/schoolArticle.model';

@AutoUnsubscribe()
@Component({
  selector: 'app-fr-library',
  standalone: true,
  imports: [
    PageheaderComponent,
    TranslateModule,
    RouterOutlet,
    ArticlesViewComponent,
  ],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './fr-library.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FrLibraryComponent extends BaseComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'academics', path: '/academics' },
    children: [
      { title: 'libraries', path: '/academics#LIBRARY_SECTION' },
      { title: 'fr_library', path: null },
    ],
  };

  public FR_LIBRARY = ACADEMIC_DATA.library.frLibrary;

  public kgArticlesArray: IPopup[] = [];
  public kgStart: number = 1;
  public kgLimit: number = 3;
  public kgTotalcount: number;

  public primaryArticlesArray: IPopup[] = [];
  public primaryStart: number = 1;
  public primaryLimit: number = 3;
  public primaryTotalcount: number;

  public preparatoryArticlesArray: IPopup[] = [];
  public preparatoryStart: number = 1;
  public preparatoryLimit: number = 3;
  public preparatoryTotalcount: number;

  public secondaryArticlesArray: IPopup[] = [];
  public secondaryStart: number = 1;
  public secondaryLimit: number = 3;
  public secondaryTotalcount: number;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef,
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.NATIONAL;
    this.schemaType = SCHEMA_TYPE.ARTICLE;
  }

  ngOnInit(): void {
    this.onKgPaginateEvent(0);
    this.onPrimPaginateEvent(0);
    this.onPrepPaginateEvent(0);
    this.onSecPaginateEvent(0);
  }

  onKgPaginateEvent($event: number) {
    this.kgStart = $event;
    this.articleType = NATIONAL_PAGES.ACADEMICS.LIBRARY.FR.KG;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.kgStart,
        limit: this.kgLimit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.kgTotalcount = data.payload?.count || 0;
          this.kgArticlesArray = this.mapArticles(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }

  onPrimPaginateEvent($event: number) {
    this.primaryStart = $event;
    this.articleType = NATIONAL_PAGES.ACADEMICS.LIBRARY.FR.PRIMARY;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.primaryStart,
        limit: this.primaryLimit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.primaryTotalcount = data.payload?.count || 0;
          this.primaryArticlesArray = this.mapArticles(
            data.payload?.list || [],
          );
          this.cdr.detectChanges();
        }
      });
  }

  onPrepPaginateEvent($event: number) {
    this.preparatoryStart = $event;
    this.articleType = NATIONAL_PAGES.ACADEMICS.LIBRARY.FR.PREPARATORY;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.preparatoryStart,
        limit: this.preparatoryLimit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.preparatoryTotalcount = data.payload?.count || 0;
          this.preparatoryArticlesArray = this.mapArticles(
            data.payload?.list || [],
          );
          this.cdr.detectChanges();
        }
      });
  }

  onSecPaginateEvent($event: number) {
    this.secondaryStart = $event;
    this.articleType = NATIONAL_PAGES.ACADEMICS.LIBRARY.FR.SECONDARY;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.secondaryStart,
        limit: this.secondaryLimit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.secondaryTotalcount = data.payload?.count || 0;
          this.secondaryArticlesArray = this.mapArticles(
            data.payload?.list || [],
          );
          this.cdr.detectChanges();
        }
      });
  }
}
